export const SIGN_UP_FORM = 'SignUpForm';
export const SIGN_IN_FORM = 'SignInForm';
export const NAME_FORM = 'NameForm';
export const ACHIEVEMENTS_FORM = 'AchievementsForm';
export const LINKS_FORM = 'LinksForm';
export const SOCIAL_MEDIA_FORM = 'SocialMediaForm';
export const CHANGE_PASSWORD_FORM = 'ChangePasswordForm';
export const DELETE_USER_FORM = 'DeleteUserForm';
